import React from 'react';
import { Link } from 'react-router-dom';

export function EmptyState({ icon: Icon, title, description, actionLabel, actionTo, onAction, testId }) {
  return (
    <div data-testid={testId || 'empty-state'} className="flex flex-col items-center justify-center rounded-3xl border border-dashed border-kelate-line bg-kelate-surface px-6 py-16 text-center shadow-[0_1px_4px_rgba(81,68,55,0.06)]">
      {Icon && <Icon size={36} className="mb-4 text-kelate-line" strokeWidth={1.5} />}
      <h3 className="text-base font-semibold text-kelate-ink">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-kelate-soft">{description}</p>}
      {actionLabel && actionTo && (
        <Link to={actionTo} data-testid="empty-state-action" className="mt-4 rounded-sm bg-kelate-darkwood px-4 py-2 text-sm font-medium text-kelate-surface hover:bg-kelate-wood">
          {actionLabel}
        </Link>
      )}
      {actionLabel && onAction && (
        <button onClick={onAction} data-testid="empty-state-action" className="mt-4 rounded-sm bg-kelate-darkwood px-4 py-2 text-sm font-medium text-kelate-surface hover:bg-kelate-wood">
          {actionLabel}
        </button>
      )}
    </div>
  );
}
